import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography } from '@mui/material';
import Header from '@/components/layout/Header';
import { useI18n } from '@/hooks/useI18n';

const PrivacyPolicyPage = () => {
    const navigate = useNavigate();
    const { t } = useI18n();

    return (
        <>
            <Header title={t('pages.privacy.title')} onBack={() => navigate('/')} />
            <Container maxWidth="lg" sx={{ py: 4 }}>
                <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {t('pages.privacy.title')}
                </Typography>
                <Typography variant="body1">
                    {t('pages.privacy.content')}
                </Typography>
                {/* {t('pages.privacy.fullContentComment')} */}
            </Container>
        </>
    );
};

export default PrivacyPolicyPage;
